import React, { Attributes, FC } from "react";
import { Checkbox, Form, Text } from "rsuite";
import { FormGroupProps } from "rsuite/esm/FormGroup/FormGroup";
import { CheckboxProps } from "rsuite/esm/Checkbox/Checkbox";

import { TenantFeatureGroup } from "store/environments/tenants/tenant-configurations/tenant-configurations-types";

export interface Props extends FormGroupProps, CheckboxProps, Attributes {
    title?: string;
    helpText?: string;
    group: TenantFeatureGroup;
}

const Group: FC<Props> = ({ key, helpText, title, ...props }: Props) => {
    return (
        <Form.Group key={key} {...props}>
            <Checkbox
                {...props}
                key={key}
                className={"feature-configurations__checkbox"}
            >
                <Text style={{ display: "inline-block" }}>{title}</Text>
                <Form.HelpText
                    tooltip
                    className={"feature-configurations__help-block"}
                >
                    {helpText}
                </Form.HelpText>
            </Checkbox>
        </Form.Group>
    );
};

export default Group;
